import { useTranslation } from 'react-i18next';

export default function Partners() {
  const { t } = useTranslation('common');

  const jessycaExpertise = t('partners.jessyca.expertiseList', { returnObjects: true }) as string[];
  const julianaExpertise = t('partners.juliana.expertiseList', { returnObjects: true }) as string[];

  return (
    <section id="partners" className="py-24 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-bold text-gray-500 tracking-wider uppercase mb-3">
            {t('partners.badge')}
          </p>
          <h2 className="text-5xl font-serif text-gray-900 mb-6">
            {t('partners.title')} <span className="italic">{t('partners.titleItalic')}</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            {t('partners.description')}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8">
          <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300">
            <div className="flex items-center gap-6 mb-6">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex-shrink-0">
                <span className="text-3xl font-bold text-white">JA</span>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">{t('partners.jessyca.name')}</h3>
                <p className="text-sm text-gray-600 font-medium">{t('partners.jessyca.title')}</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-6">
              <span className="px-4 py-2 bg-amber-100 text-amber-800 text-xs font-semibold rounded-full">
                {t('partners.jessyca.badge1')}
              </span>
              <span className="px-4 py-2 bg-gray-100 text-gray-800 text-xs font-semibold rounded-full">
                {t('partners.jessyca.badge2')}
              </span>
            </div>

            <p className="text-sm text-gray-700 leading-relaxed mb-6">
              {t('partners.jessyca.description')}
            </p>

            <div className="mb-6">
              <p className="text-xs font-bold text-gray-500 tracking-wider uppercase mb-3">
                {t('partners.jessyca.expertise')}
              </p>
              <ul className="space-y-2">
                {jessycaExpertise.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-amber-600 text-base flex-shrink-0 mt-0.5"></i>
                    <span className="text-sm text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <p className="text-sm text-gray-600 leading-relaxed italic mb-4">
              {t('partners.jessyca.approach')}
            </p>

            <p className="text-xs text-gray-500 leading-relaxed border-t border-gray-200 pt-4">
              {t('partners.jessyca.admission')}
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300">
            <div className="flex items-center gap-6 mb-6">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-900 rounded-full flex-shrink-0">
                <span className="text-3xl font-bold text-white">JA</span>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">{t('partners.juliana.name')}</h3>
                <p className="text-sm text-gray-600 font-medium">{t('partners.juliana.title')}</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-6">
              <span className="px-4 py-2 bg-amber-100 text-amber-800 text-xs font-semibold rounded-full">
                {t('partners.juliana.badge1')}
              </span>
              <span className="px-4 py-2 bg-gray-100 text-gray-800 text-xs font-semibold rounded-full">
                {t('partners.juliana.badge2')}
              </span>
            </div>

            <p className="text-sm text-gray-700 leading-relaxed mb-6">
              {t('partners.juliana.description')}
            </p>

            <div className="mb-6">
              <p className="text-xs font-bold text-gray-500 tracking-wider uppercase mb-3">
                {t('partners.juliana.expertise')}
              </p>
              <ul className="space-y-2">
                {julianaExpertise.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-gray-700 text-base flex-shrink-0 mt-0.5"></i>
                    <span className="text-sm text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <p className="text-sm text-gray-600 leading-relaxed italic mb-4">
              {t('partners.juliana.approach')}
            </p>

            <p className="text-xs text-gray-500 leading-relaxed border-t border-gray-200 pt-4">
              {t('partners.juliana.admission')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
